import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMinimizePictureSizeConfig } from '@/data/landingConfig/landingMinimizePictureSizeConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MinimizePictureSize } from './schemaObject';

interface Props {}
const MinimizePictureSize: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MinimizePictureSize} />
			<LandingTemplate
				data={landingMinimizePictureSizeConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default MinimizePictureSize;
